import { BaseLink, Picture, Typography } from '@which/seatbelt'

import classnames from 'classnames'

import type { RecommendedContentType } from '../../models'
import styles from './RecommendationsImageLinksLayout.module.scss'

type LinkWithImageProps = {
  whichId: string
  sectionTitle: string
  recommendation: RecommendedContentType
  index: number
  modelId: string
  position?: string
}

const LinkWithImage = ({
  whichId,
  sectionTitle,
  recommendation,
  index,
  modelId,
  position,
}: LinkWithImageProps) => {
  const title = recommendation.__typename == 'RecommendedArticle' ? recommendation.title : ''
  const { href, image = '' } = recommendation

  return (
    <li key={`${title}-${index}`} className={styles.multiLinkListItem}>
      <BaseLink
        appearance="secondary"
        aria-label={title}
        className={classnames('sb-link-secondary', styles.imageTextWrapper)}
        data-testid="navigation-link"
        href={href}
        data-which-id={whichId}
        data-section={sectionTitle}
        data-card-name={title}
        data-index={(index + 1).toString()}
        data-content-id={recommendation.id}
        data-model-id={modelId}
        data-spec={position}
        data-personalisation="true"
      >
        <Picture
          aspectRatioMain="four-to-three"
          aspectRatioSm="one-to-one"
          className={styles.image}
          data-testid="navigation-link-image"
          src={image}
        />
        <Typography
          className={styles.articleTitle}
          tag="span"
          textStyle="sb-text-interface-body-default-regular"
        >
          <span className="sb-link-animation-wrapper">{title}</span>
        </Typography>
      </BaseLink>
    </li>
  )
}

type RecommendationsImageLinksLayoutProps = {
  recommendations: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
  position?: string
}

export const RecommendationsImageLinksLayout = ({
  recommendations,
  title,
  whichId,
  modelId,
  position,
}: RecommendationsImageLinksLayoutProps) => (
  <section className={styles.recommendationsImageLinks}>
    <Typography
      tag="h2"
      textStyle="sb-text-heading-small"
      className="sb-padding-bottom-3"
      data-testid="multi-link-title"
    >
      {title}
    </Typography>

    <ul className={styles.multiLinkList}>
      {recommendations.map((recommendation, index) => (
        <LinkWithImage
          whichId={whichId}
          sectionTitle={title}
          recommendation={recommendation}
          index={index}
          modelId={modelId}
          position={position}
          key={index}
        />
      ))}
    </ul>
  </section>
)
